<template>
  <div>
    <div v-if="loading" class="flex justify-center items-center min-h-[200px]">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-custom-yellow"></div>
    </div>
    <template v-else>
      <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5">
        <table class="w-full text-left rtl:text-right text-gray-700">
          <thead>
            <tr class="bg-gray-100">
              <th scope="col" class="p-4">
                <div class="flex items-center">
                  <input
                    id="checkbox-all-search"
                    type="checkbox"
                    class="w-4 h-4 text-custom-yellow bg-gray-100 border-gray-300 rounded focus:ring-custom-yellow dark:focus:ring-custom-yellow dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label for="checkbox-all-search" class="sr-only">checkbox</label>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Pint Serial
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Blood Group
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Unit Product
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Issuing Facility
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Issued To Facility
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Issue Date
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Status
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(log, index) in issuedLogs" :key="index" class="border-b">
              <td class="w-4 p-4">
                <div class="flex items-center">
                  <input :id="'checkbox-table-search-' + index" type="checkbox" class="w-4 h-4" />
                  <label :for="'checkbox-table-search-' + index" class="sr-only">checkbox</label>
                </div>
              </td>
              <td class="px-6 py-1">{{ log.product.pint_serial || '' }}</td>
              <td class="px-6 py-1">{{ log.product.blood_group.description || '' }}</td>
              <td class="px-6 py-1">{{ log.product.unit_product.description || '' }}</td>
              <td class="px-6 py-1">{{ log.facility_issuing.name || '' }}</td>
              <td class="px-6 py-1">{{ log.facility_issued_to.name || '' }}</td>
              <td class="px-6 py-1">{{ formatDateISO(log.issue_date) }}</td>
              <td class="px-6 py-1">
                <span 
                  class="inline-flex justify-center px-2.5 py-1 w-full rounded-md"
                  :class="{
                    'bg-green-200 text-green-800': ['Issued', 'Completed', 'Split', 'Screened', 'Okay'].includes(log.status),
                    'bg-blue-100 text-blue-800': ['Transfused', 'Transfused With Reaction'].includes(log.status),
                    'bg-red-100 text-red-800': ['Disposed', 'Expired'].includes(log.status)
                  }"
                >
                  {{ log.status }}
                </span>
              </td>
              <td class="flex items-center px-4 py-2">
                <CustomButton
                  label="View Details"
                  @click="openDetailsModal(log)"
                  :disabled="isLoading[log.ecosystem_issueout_log_id]"
                  :bg-class="isLoading[log.ecosystem_issueout_log_id] ? 'bg-gray-300 cursor-not-allowed' : 'bg-custom-yellow py-1'"
                />
                <div
                  v-if="isLoading[log.ecosystem_issueout_log_id]"
                  class="ml-2 animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-gray-900"
                ></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="text-center text-gray-600 mb-2">{{ showingText }}</p>
      <div class="flex justify-center gap-4 mt-4">
        <button
          @click="previousPage"
          :disabled="loading || currentPage === 1"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
        >
          <svg
            class="w-6 h-6"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m15 19-7-7 7-7"
            />
          </svg>
          Previous
        </button>
        <div class="flex items-center gap-2">
          <button
            v-for="page in visiblePages"
            :key="page"
            @click="goToPage(page)"
            :class="{
              'bg-custom-blue text-white': page === currentPage,
              'text-custom-blue': page !== currentPage
            }"
            class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type="button"
            :disabled="loading || page === '...'"
          >
            <span
              class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
            >
              {{ page }}
            </span>
          </button>
        </div>
        <button
          @click="nextPage"
          :disabled="loading || currentPage === totalPages"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
        >
          Next
          <svg
            class="w-6 h-6"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m9 5 7 7-7 7"
            />
          </svg>
        </button>
      </div>
      
      <!-- Modal -->
      <div
        v-if="showModal"
        class="fixed inset-0 bg-gray-900 bg-opacity-75 flex justify-center items-center z-50 backdrop-blur-sm"
        @click.self="closeModal"
      >
        <div class="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[85vh] overflow-hidden">
          <!-- Modal header -->
          <div class="bg-orange-200 text-gray-600 px-6 py-2 flex justify-between items-center">
            <h2 class="text-xl font-bold flex items-center">
              Request Details
            </h2>
            <button
              @click="closeModal"
              class="text-gray-700 hover:bg-custom-blue-dark p-1 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-white"
            >
              <svg
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
          
          <!-- Modal content -->
          <div id="modalContent" class="p-6 overflow-y-auto" style="max-height: calc(85vh - 128px);">
            <div v-if="selectedUnit" class="space-y-6">
              <!-- Issued Unit Details -->
              <h2 class="text-xl font-bold text-gray-800">Issued Unit Details</h2>
              <div class="bg-white rounded-lg p-4 border border-gray-200">                  
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
                  <div>
                    <p class="text-sm text-gray-500 mb-1">Requesting Facility</p>
                    <p class="text-base font-medium text-gray-900">{{ selectedUnit.facility_issued_to.name || 'N/A' }}</p>
                  </div>
                  <div>
                    <p class="text-sm text-gray-500 mb-1">Date Issued</p>
                    <p class="text-base font-medium text-gray-900">{{ formatDateISO(selectedUnit.issue_date) || 'N/A' }}</p>
                  </div>
                  <div>
                    <p class="text-sm text-gray-500 mb-1">Unit Serial Number</p>
                    <p class="text-base font-medium text-gray-900">{{ selectedUnit.product.pint_serial || 'N/A' }}</p>
                  </div>
                  <div>
                    <p class="text-sm text-gray-500 mb-1">Blood Group</p>
                    <p class="text-base font-medium text-gray-900">{{ selectedUnit.product.blood_group.description || 'N/A' }}</p>
                  </div>
                  <div>
                    <p class="text-sm text-gray-500 mb-1">Component</p>
                    <p class="text-base font-medium text-gray-900">{{ selectedUnit.product.unit_product.description || 'N/A' }}</p>
                  </div>
                </div>
              </div>
              
              <!-- Unit History -->
              <div class="mt-8">
                <h2 class="text-xl font-bold text-gray-800 mb-4">Unit History</h2>
                <div class="relative overflow-x-auto mt-2 rounded-lg shadow-sm border border-gray-200">
                  <table class="w-full border-collapse">
                    <thead>
                      <tr class="bg-gray-50">
                        <th class="py-3 px-4 text-left text-sm font-medium text-gray-500 border-b">Action</th>
                        <th class="py-3 px-4 text-left text-sm font-medium text-gray-500 border-b">Action Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(unit, index) in selectedUnit.logs"
                        :key="index"
                        class="hover:bg-gray-100 transition-colors"
                      >
                        <td class="py-4 px-4 text-sm text-gray-900 border-b">
                          <span 
                            class="inline-flex justify-center px-2.5 py-1 w-7/12 rounded-md bg-blue-100 text-blue-800"
                          >
                            {{ unit.status }}
                          </span>
                        </td>
                        <td class="py-4 px-4 text-sm text-gray-900 border-b">{{ formatDateISO(unit.created_at) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import api from "@/services/api";
import SweetAlertService from '@/services/SweetAlertService';

export default {
  name: "IssuedOutRequests",
  components: {
    CustomButton,
  },
  props: {
    searchQuery: {
      type: String,
      default: ''
    },
    filters: {
      type: Object,
      default: () => ({
        blood_group: '',
        status: '',
        unit_product: '',
        start_date: '',
        end_date: ''
      })
    }
  },
  data() {
    return {
      issuedLogs: [],
      error: null,
      isLoading: {},
      loading: false,
      currentPage: 1,
      totalPages: 1,
      perPage: 10,
      totalCount: 0,
      showModal: false,
      selectedUnit: null,
      facility_logo: '',
      localSearchQuery: '',
      debounceTimer: null
    };
  },
  computed: {
    visiblePages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const delta = 2;
      const range = [];
      const rangeWithDots = [];
      let l;

      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
          range.push(i);
        }
      }

      range.forEach(i => {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push('...');
          }
        }
        rangeWithDots.push(i);
        l = i;
      });

      return rangeWithDots;
    },
    showingText() {
      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = start + this.issuedLogs.length - 1;
      return `Showing ${start}-${end} of ${this.totalCount}`;
    }
  },
  created() {
    this.user = this.$store.getters["auth/user"];
    this.facility_logo = this.user.user_roles[0]?.facility_department?.facility?.logo;
    this.localSearchQuery = this.searchQuery;
    this.getEcosystemIssuedUnit();
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.currentPage = 1;
        this.getEcosystemIssuedUnit();
      }
    },
    searchQuery: {
      handler(newVal) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.localSearchQuery = newVal;
          this.currentPage = 1;
          this.getEcosystemIssuedUnit();
        }, 300);
      },
      immediate: true
    }
  },
  methods: {
    async getEcosystemIssuedUnit() {
      this.loading = true;
      try {
        const queryParams = {
          blood_group: this.filters.blood_group,
          status: this.filters.status,
          unit_product: this.filters.unit_product,
          start_date: this.filters.start_date,
          end_date: this.filters.end_date,
          search_query: this.localSearchQuery,
          page: this.currentPage,
          per_page: this.perPage
        };

        const response = await api.fetchIssuedLogs(queryParams);
        this.issuedLogs = response.data || [];
        this.currentPage = response.current_page || 1;
        this.totalPages = response.total_pages || 1;
        this.totalCount = response.total_count || 0;
      } catch (error) {
        this.error = error.response?.data?.errors || error.message || "Failed to fetch issued logs";
        await SweetAlertService.showError('Error', this.error);
      } finally {
        this.loading = false;
      }
    },
    async getSingleIssuedUnitLogs(product_id) {
      this.loading = true;
      try {
        const response = await api.fetchSingleIssuedUnitLogs(product_id);
        this.selectedUnit = response.data || response;
      } catch (error) {
        this.error = error.response?.data?.errors || error.message || "Failed to fetch unit logs";
        await SweetAlertService.showError('Error', this.error);
      } finally {
        this.loading = false;
      }
    },
    openDetailsModal(unit) {
      this.showModal = true;
      this.getSingleIssuedUnitLogs(unit.product_id);
    },
    closeModal() {
      this.showModal = false;
      this.selectedUnit = null;
    },
    applyFilters() {
      this.currentPage = 1;
      this.getEcosystemIssuedUnit().catch(async () => {
        await SweetAlertService.showError('Error', 'Failed to apply filters');
      });
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getEcosystemIssuedUnit();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getEcosystemIssuedUnit();
      }
    },
    goToPage(page) {
      if (page !== '...' && page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getEcosystemIssuedUnit();
      }
    },
    formatDateISO(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    }
  }
}
</script>

<style lang="css" scoped>
/* No print-specific styles needed since #printSection is removed */
</style>